import React from 'react';
import whitelogo from '../assets/img/logo.png';
import { Link } from 'react-router-dom';

function Footer () {
  return (
   <div className='header footer'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-12'>
        
          </div>
        </div>
        </div>
   </div>
  )
}

export default Footer;